import CategoryList from '../components/CategoryList';

const Main = () => {
    return (
        <CategoryList />
    );
}

export default Main;